const useUserInitials = () => {
    
    const getOne = (firstName, lastName) => {
        return `${firstName.charAt(0)}${lastName.charAt(0)}`;
    };

    return [{ getOne }];
};

export default useUserInitials;
